

export default [
  {
    path: '/shopping-cart',
    component: () => import('@/views/shopping-cart/ShoppingCart.vue'),
    meta: { 
      title: 'Shopping Cart', 
      requiresAuth: true ,
      requiresAmazon: true
    },
  }
]